
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'VFormGroupSelect',
  props: {
    formGroupClass: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    forKey: {
      type: String,
      required: false,
      default: '',
    },
    yupErrorsVariable: {
      type: String,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
    labelClass: {
      type: String,
      required: false,
    },
  },
});
